import { View, Text } from "react-native";
import React, { useState } from "react";

import BlockRowView from "./BlockRowView";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import AddRow from "../Components/AddRow";

import { observer, Observer } from "mobx-react";

import { useTranslation } from "react-i18next";

import { useScreenDimensions, useDevice } from "../_layout";
import AddBlockView from "./AddBlockView";

const BlockListView = observer(({ client }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();
  const [showingAddBlock, setShowingAddBlock] = useState(false);

  return (
    <View style={{}}>
      {client.sortedLabels.map((label, labelIdx) => (
        <View key={labelIdx}>
          {label !== "" && (
            <Text
              style={{
                fontWeight: "500",
                color: Colors.grayColor,
                marginBottom: 8,
                marginLeft: 2,
              }}
            >
              {label}
            </Text>
          )}
          {client.sortedBlocksInLabel(label).map((block, idx) => (
            <BlockRowView
              block={block}
              labelIdx={labelIdx}
              idx={idx}
              key={block.id}
            />
          ))}
        </View>
      ))}
      <AddRow action={() => setShowingAddBlock(true)} blockAdd={true} />
      {showingAddBlock && (
        <AddBlockView
          isVisible={showingAddBlock}
          onClose={() => setShowingAddBlock(false)}
          client={client}
        />
      )}
    </View>
  );
});

export default BlockListView;
